import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../context/theme/ThemeContext";
import { t } from "i18next";
import { getResponseStatusBadge, getSendingStatusBadge } from "./Helper";
import { modalityRowBadgeColor } from "../../constants/Constants";
import RowBadge from "../StudyList/components/Badge/RowBadge";
import { getFormatedDate } from "../IssuesAndTroubleshooting/helper/helper";

const ColumnsAIRequest = () => {

  let idWidth = 'calc((100vw - 200px) / 30)';
  let narrowWidth = 'calc((100vw - 200px) / 17)';
  let mediumWidth = 'calc((100vw - 200px) / 12)';
  let wideWidth = 'calc((100vw - 200px) / 9)';
  let paddingChild = '15px 0px 15px 10px';

  return [
    {
      id: "id",
      style: { width: idWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: idWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Job ID</span>,
      accessor: "id",
      accessorKey: "id",
      show: true,
      cell: (cell) => {
        return (
          <div className="user-sub-heading">
            <div style={{marginRight:'5px'}}> {cell.row.original.id} </div>
          </div>
        )
      },
    },
    {
      id: "patientDetails",
      style: { width: mediumWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: mediumWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Patient Details</span>,
      accessor: "patientDetails",
      accessorKey: "patientDetails",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
            <span >
              <div style={{display:"flex", flexDirection:"column"}}>
                <CustomToolTipHost content={`${t("patient.name")}: ${cell.row.original.patientName}`} id={"tooltip_"}>
                  <span className="study-list-patientDetails-name">
                    {cell.row.original.patientName}
                  </span>
                </CustomToolTipHost>
                <CustomToolTipHost  content={`Patient Id : ${cell.row.original.patientId}`} id={"tooltip_"}>
                  <span className="study-list-patientDetails-id">
                   P:{`${cell.row.original.patientId}`}
                  </span>
                </CustomToolTipHost>
                <CustomToolTipHost  content={`Accession Number : ${cell.row.original.accessionNumber}`} id={"tooltip_"}>
                  <span className="study-list-patientDetails-id">
                    A:{`${cell.row.original.accessionNumber}`}
                  </span>
                </CustomToolTipHost>
                <CustomToolTipHost  content={`Order Id : ${cell.row.original.orderId}`} id={"tooltip_"}>
                  <span className="study-list-patientDetails-id">
                    O:{`${cell.row.original.orderId}`}
                  </span>
                </CustomToolTipHost>
              </div>
            </span>
        </div>
      ),
    },
    {
      id: "studyDetails",
      style: { width: mediumWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: mediumWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Study Details</span>,
      accessor: "studyDetails",
      accessorKey: "studyDetails",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
            <span >
              <div style={{display:"flex", flexDirection:"column"}}>
                <CustomToolTipHost content={`Study Description : ${cell.row.original.studyDescription}`} id={"tooltip_"}>
                  <span className="studylist-study-description">{`${cell.row.original.studyDescription}`}</span>
                </CustomToolTipHost>
                <RowBadge
                  customClassName = "study-list-modality-badge"
                  tooltipText={`Modality: ${cell.row.original.modality}`}
                  name={cell.row.original.modality}
                  colorObj={modalityRowBadgeColor(
                    cell.row.original.modality
                  )}
                  isQueueBadge={true}
                />
              </div>
            </span>
        </div>
      ),
    }, 
    {
      id: "firm",
      style: { width: narrowWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: narrowWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Firm Name</span>,
      accessor: "firm",
      accessorKey: "firm",
      show: true,
      cell: (cell) => <div className="user-sub-heading study-list-assignment-details-text">
        <CustomToolTipHost content={cell.row.original.clientName} id={"tooltip_"}>
          {cell.row.original.clientName}
        </CustomToolTipHost>
      </div>,
    },
    {
      id: "destination",
      style: { width: narrowWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: narrowWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Destination</span>,
      accessor: "destination",
      accessorKey: "destination",
      show: true,
      cell: (cell) => <div className="user-sub-heading study-list-assignment-details-text">{cell.row.original.destination}</div>,
    },
    {
      id: "requestDetails",
      style: { width: wideWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: wideWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Request</span>,
      accessor: "requestDetails",
      accessorKey: "requestDetails",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
            <span >
              <div style={{display:"flex", flexDirection:"column"}}>
                <CustomToolTipHost content={`Request Created On: ${getFormatedDate(cell.row.original.createdAt, "DD-MMM-YY HH:mm")}`} id={"tooltip_"}>
                  <span className="study-list-study-date" style={{marginTop: '0px'}}>Request Created On: {getFormatedDate(cell.row.original.createdAt, "DD-MMM-YY HH:mm")}</span>
                </CustomToolTipHost>
                <CustomToolTipHost content={`Batch Created On: ${getFormatedDate(cell.row.original.batchCreatedAt, "DD-MMM-YY HH:mm")}`} id={"tooltip_"}>
                  <span className="study-list-study-date">Batch Created On: {getFormatedDate(cell.row.original.batchCreatedAt, "DD-MMM-YY HH:mm")}</span>
                </CustomToolTipHost>
                <CustomToolTipHost content={`Study Pushed On: ${getFormatedDate(cell.row.original.studyPushedAt, "DD-MMM-YY HH:mm")}`} id={"tooltip_"}>
                  <span className="study-list-study-date">Study Pushed On: {getFormatedDate(cell.row.original.studyPushedAt, "DD-MMM-YY HH:mm")}</span>
                </CustomToolTipHost>
              </div>
            </span>
        </div>
      ),
    },
    {
      id: "responseDetails",
      style: { width: wideWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: wideWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Response</span>,
      accessor: "responseDetails",
      accessorKey: "responseDetails",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
            <span >
              <div style={{display:"flex", flexDirection:"column"}}>
                <CustomToolTipHost content={`Response Received On: ${getFormatedDate(cell.row.original.responseRecievedAt, "DD-MMM-YY HH:mm")}`} id={"tooltip_"}>
                  <span className="study-list-study-date" style={{marginTop: '0px'}}>Response Received On: {getFormatedDate(cell.row.original.responseRecievedAt, "DD-MMM-YY HH:mm")}</span>
                </CustomToolTipHost>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "5px" }}>
                  <span className="study-list-study-date" style={{ marginTop: 0 }}>Response:</span>
                  {getResponseStatusBadge(cell.row.original.responseStatus)}
                </div>
              </div>
            </span>
        </div>
      ),
    },
    {
      id: "status",
      style: { width: mediumWidth },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: mediumWidth,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Sending Status</span>,
      accessor: "status",
      accessorKey: "status",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
            
              <div style={{display:"flex", flexDirection:"column", gap: "5px"}}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <span className="study-list-study-date" style={{ marginTop: 0}}>Sending:</span>
                  {getSendingStatusBadge(cell.row.original.sendingStatus)}
                </div>

                <div className="study-list-study-date" style={{ marginTop: 0 }}>
                 <span>
                                   Images Sent:{" "}
                                   <CustomToolTipHost
                                     content="Successfully Sent Images"
                                     id={`tooltip_success_${cell.row.id}`}
                                   >
                                     <span>{cell.row.original.success}</span>
                                   </CustomToolTipHost>
                                   {" / "}
                                   <CustomToolTipHost
                                     content="Total Sent Images"
                                     id={`tooltip_total_${cell.row.id}`}
                                   >
                                     <span>{cell.row.original.total}</span>
                                   </CustomToolTipHost>
                                 </span>
                </div>

                <div className="study-list-study-date" style={{ marginTop: 0 }}>
                  Total Images: {cell.row.original.totalInStudy}
                </div>
              </div>
            
        </div>
      ),
    }
  ];
};
export default ColumnsAIRequest;